import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { Divider } from 'legacyComponents/styled/lib';

import { Follow } from 'apps/content/views/follow';
import { clientStore } from 'apps/client/app';
import { modalStore } from 'apps/modals/app';
import { imageSrc } from 'apps/file/utils';
import { conf as mainConf } from 'apps/config.yaml';
import {
  ProfileWrapper,
  ProjectImage,
  Title,
  Bio,
  FollowButtonWrapper,
} from 'apps/modals/connResultsModal/styles';

@observer
export class ProjectListItem extends React.Component {
  clickProject = () => {
    modalStore.ClearComponent();
    const { project } = this.props;
    let spaceType = 'profile';
    if (project.spacePath[0] === '+') {
      spaceType = 'initiative';
    }
    const route = `${spaceType}.project`;
    clientStore.routerStore.navigate(route, {
      [spaceType]: project.spacePath,
      slug: project.slug,
    });
  };

  render() {
    const { project } = this.props;
    const { id, image, space, slug, descriptionSnippet, spacePath } = project;
    return (
      <div key={id}>
        <ProfileWrapper>
          <ProjectImage
            onClick={this.clickProject}
            size='50px'
            src={imageSrc(
              image,
              project.imageFallbackPath,
              mainConf.imgSizes.project.large,
            )}
          />
          <Title onClick={this.clickProject} project>
            {spacePath[0]}
            {space.content.slug}/{slug}
          </Title>
          <Bio project>{descriptionSnippet}</Bio>
          <FollowButtonWrapper>
            <Follow content={project.content} small />
          </FollowButtonWrapper>
        </ProfileWrapper>
        <Divider />
      </div>
    );
  }
}

ProjectListItem.propTypes = {
  project: PropTypes.object,
};
